'use client'

import { useEffect, useState } from 'react'
import type { CustomFlowbiteTheme } from 'flowbite-react'
import { Dropdown, DropdownItem } from 'flowbite-react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

const customTheme: CustomFlowbiteTheme['dropdown'] = {
  arrowIcon: 'ml-auto h-4 w-4',
  floating: {
    base: ' sm:hidden z-20 w-fit rounded divide-y divide-gray-100 shadow focus:outline-none',
    target:
      'sm:hidden justify-between w-full bg-white rounded border border-gray-200 text-gray-900 enabled:hover:bg-white focus:ring-0 [&>span]:w-full',
  },
}

const tabList: { [key: string]: string } = {
  register_now: 'Register Now',
  ongoing: 'Ongoing',
  upcoming: 'Upcoming',
  closed: 'Closed',
}

export default function AppTabs() {
  const searchParams = useSearchParams()
  const [activeTab, setActiveTab] = useState(Object.keys(tabList)[0])

  useEffect(() => {
    const currentTab = searchParams.get('state')
    setActiveTab(currentTab ?? Object.keys(tabList)[0])
  }, [])

  const handleTabSelected = (state: string) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', '1')
    params.set('state', state)

    setActiveTab(state)
    window.history.replaceState(null, '', `?${params.toString()}`)
  }

  const renderDropdown = () => (
    <Dropdown theme={customTheme} label={tabList[activeTab]}>
      {Object.entries(tabList).map(([key, label]) => (
        <DropdownItem key={key} onClick={() => handleTabSelected(key)}>
          {label}
        </DropdownItem>
      ))}
    </Dropdown>
  )

  const renderTabs = () => (
    <ul className="tabs hidden sm:flex flex-wrap gap-6 text-gray-500 text-lg font-medium text-center">
      {Object.entries(tabList).map(([key, label]) => (
        <li
          key={key}
          onClick={() => handleTabSelected(key)}
          className={`inline-block border-b-2 cursor-pointer ${
            activeTab === key
              ? 'text-gray-900 border-gray-900'
              : 'border-transparent hover:text-gray-600 hover:border-gray-300'
          }`}
        >
          {label}
        </li>
      ))}
    </ul>
  )

  return (
    <>
      {renderDropdown()}
      {renderTabs()}
    </>
  )
}
